import React, { useEffect, useRef } from "react";
import "./HeroSection.css";

const HeroSection = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.playbackRate = 0.95; // 🔹 0.5 = half speed (slower)
    }
  }, []);

  return (
    <section className="position-relative overflow-hidden pb-0 pt-xl-9 hero-section">
      {/* Background Video */}
      <video
        ref={videoRef}
        autoPlay
        muted
        loop
        playsInline
        id="myVideo"
        className="hero-video"
      >
        <source src="/videos/elegant-video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Optional Decoration */}
      <div className="position-absolute top-0 start-0 ms-n7 d-none d-xl-block">
        <img
          src="assets/images/elements/decoration-pattern.svg"
          alt="home"
        />
      </div>

      {/* Foreground Content */}
      <div className="container pt-4 pt-sm-5 position-relative text-white">
        <div className="row g-xl-5 align-items-center">
          <div className="col-xl-7 mb-5 mb-xl-0">
            <div className="pe-xxl-4" style={{ marginTop: "-300px" }}>
              <h1 className="mt-3 lh-base" style={{ fontSize: "60px", color: "#fff" }}>
                Elegant Advisors and Consultants
                <ul className="flip">
                  <li><span>Auditing</span></li>
                  <li><span>Taxation</span></li>
                  <li><span>Accounting</span></li>
                </ul>
              </h1>

              <p className="mb-0 mt-4 mt-md-5">
                We bring deep expertise and practical knowledge in accounting,
                taxation, and financial consultancy. Our firm specializes in
                delivering reliable and tailored financial solutions to all sizes
                of businesses, helping them maintain accounting, ensure compliance,
                optimize tax planning, and improve overall financial efficiency.
              </p>

              <form className="col-md-10 bg-body border rounded-2 position-relative p-2 mt-4 mt-md-5">
                <div className="input-group">
                  <input
                    className="form-control focus-shadow-none border-0 me-1"
                    type="email"
                    placeholder="Enter your email address"
                  />
                  <button type="button" className="btn btn-dark rounded-2 mb-0">
                    Start trial!
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div className="col-md-10 col-xl-5 position-relative mx-auto mt-7 mt-xl-0">
            <img src="img/home.png" className="rounded" alt="hero-img" />
            <div className="d-inline-block bg-dark rounded-4 position-absolute start-0 bottom-0 mb-md-4 ms-md-n5 p-3">
              <div className="d-flex align-items-center">
                <h6 className="text-white mb-0 me-2">100+</h6>
                <ul className="avatar-group mb-0 align-items-center">
                  <li className="avatar avatar-xs">
                    <img
                      className="avatar-img rounded-circle"
                      src="assets/images/avatar/06.jpg"
                      alt="avatar"
                    />
                  </li>
                  <li className="avatar avatar-xs">
                    <img
                      className="avatar-img rounded-circle"
                      src="assets/images/avatar/05.jpg"
                      alt="avatar"
                    />
                  </li>
                  <li className="avatar avatar-xs">
                    <img
                      className="avatar-img rounded-circle"
                      src="assets/images/avatar/02.jpg"
                      alt="avatar"
                    />
                  </li>
                  <li className="avatar avatar-xs">
                    <img
                      className="avatar-img rounded-circle"
                      src="assets/images/avatar/03.jpg"
                      alt="avatar"
                    />
                  </li>
                  <li className="avatar avatar-xs">
                    <img
                      className="avatar-img rounded-circle"
                      src="assets/images/avatar/04.jpg"
                      alt="avatar"
                    />
                  </li>
                </ul>
              </div>
              <p className="text-white mb-0 mt-2">Total visitors per Month</p>
            </div>

            <div className="d-inline-block card card-body shadow rounded-4 position-absolute end-0 top-0 p-3 me-lg-n3 me-xxl-n7 mt-n5 d-none d-sm-block">
              <img
                src="assets/images/elements/trustpilot.svg"
                className="light-mode-item h-20px mb-2"
                alt="Client-img"
              />
              <img
                src="assets/images/elements/trustpilot-light.svg"
                className="dark-mode-item h-20px mb-2"
                alt="Client-img"
              />
              <div className="d-flex align-items-center">
                <img
                  src="assets/images/elements/trustpilot-star.svg"
                  className="h-30px"
                  alt="rating-img"
                />
                <h6 className="font-base fw-bold ms-1 mb-0">4.8/5.0</h6>
              </div>
              <p className="small mb-0 mt-2">Reviewed by 365 users</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
